<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">Kick-off Meeting</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span
            class="badge"
            [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }"
          >
            {{
              stepDetails?.step_status == 0
                ? "INITIATION PENDING"
                : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container
          *ngIf="stepDetails?.can_edit"
        >
          <button
            class="btn btn-primary me-2"
              (click)="routeConfig.emit({isRouteConfig: true})"
          >
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

       
      </div>
    </div>
  </div>

  <hr class="my-3" />

  <form [formGroup]="commentForm">
    <div class="row mb-4">
      <div class="col-md-6 d-flex gap-2">
        <label class="bg-primary text-white p-2 "
          >Meeting Date <b class="text-warning">*</b></label
        >
        <input
          type="date"
          class="form-control"
          formControlName="meeting_date"
          [disabled]="isEditorDisabled"
        />
      </div>
      <div class="col-md-6 d-flex gap-2">
        <label class="bg-primary text-white p-2 ">Meeting Venue <b class="text-warning">*</b></label>
        <input inputId="meeting_venue" formControlName="meeting_venue" [disabled]="true" class="w-full" />
        
      </div>
      <div class="col-md-6 d-flex gap-2 mt-2">
        <label class="bg-primary text-white p-2 ">Meeting Time <b class="text-warning">*</b></label>
        <input type="time" id="meeting_time" class="form-control" formControlName="meeting_time" [disabled]="true" />
      </div>
    </div>
    <div
      class="mb-4 editor-container"
      [class.readonly-editor]="isEditorDisabled"
    >
      <label class="bg-primary text-white p-2 ">{{ schemeType === 'rev' ? 'Comment' : 'Justification' }}</label>

      <editor
        [init]="init"
        formControlName="comment"
        [disabled]="isEditorDisabled"
      ></editor>
    </div>
  </form>
    <!-- Document Upload Section -->
  <!-- <div class="row mb-4">
    <app-upload-document [title]="stepDetails.name"  ></app-upload-document>
  </div> -->
   <div class="row mb-4">
   
    <app-upload-document [title]="stepDetails?.name" [isEditable]="stepDetails?.can_edit"> </app-upload-document>
    
  </div>
</div>
